import { AddressCreationState, AddressState } from "../model/AddressState";

export class AddressValidator {
  validateCreation = (a: AddressCreationState): AddressValidation => {
    const v = {
      zip: !!a.zipCode && a.zipCode.length === 5,
      companyName: !!a.companyName && a.companyName.length > 0,
      street: !!a.street && a.street.length > 0,
      houseNumber: !!a.houseNumber && a.houseNumber.length > 0,
      overall: true
    };
    v.overall =
      v.zip &&
      v.companyName &&
      v.street &&
      v.houseNumber &&
      !!a.validatedZip &&
      a.validatedZip.isSupported;
    return v;
  };

  isValidState = (a: AddressState): boolean => {
    const hasId = !!a.id;
    const isValidCreate =
      (a.create && this.validateCreation(a.create).overall) || false;
    return hasId || isValidCreate;
  };
}

type AddressValidation = {
  zip: boolean;
  companyName: boolean;
  street: boolean;
  houseNumber: boolean;
  overall: boolean;
};
